export const FINANCE_ATTACHMENT_UPLOAD_POLICY = "finance-attachment" as const;
export const FINANCE_ATTACHMENT_MAX_BYTES = 25 * 1024 * 1024;
export const FINANCE_ATTACHMENT_CONTENT_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "image/png",
  "image/jpeg",
] as const;
export const FINANCE_ATTACHMENT_UPLOAD_TAG = `upload-policy:${FINANCE_ATTACHMENT_UPLOAD_POLICY}`;
const financeAttachmentContentTypeSet = new Set<string>(FINANCE_ATTACHMENT_CONTENT_TYPES);

export type ManagedUploadPolicy = typeof FINANCE_ATTACHMENT_UPLOAD_POLICY;

export function getManagedUploadPolicy(policy: ManagedUploadPolicy | undefined) {
  if (policy === FINANCE_ATTACHMENT_UPLOAD_POLICY) {
    return {
      allowedContentTypes: [...FINANCE_ATTACHMENT_CONTENT_TYPES],
      maximumSizeInBytes: FINANCE_ATTACHMENT_MAX_BYTES,
      tag: FINANCE_ATTACHMENT_UPLOAD_TAG,
    };
  }

  return null;
}

export function assertFinanceAttachmentFile(file: {
  mimetype: string | null;
  tags: string[];
  type: string;
}) {
  const contentType = file.mimetype || file.type;
  if (!financeAttachmentContentTypeSet.has(contentType)) {
    throw new Error("Finance attachments must be PDF, Office, CSV, PNG, or JPEG files.");
  }
  if (!file.tags.includes(FINANCE_ATTACHMENT_UPLOAD_TAG)) {
    throw new Error("Finance attachments must be uploaded through the finance attachment control.");
  }
}
